<template>
  <node-view-wrapper :class="['md-attachment-node', { 'is-selected': selected }]">

    <div v-if="uploading" class="md-attachment md-attachment-card md-attachment-uploading">
      <div class="md-attachment-left" :style="{ background: mimeColor.bg }">
        <i class="fas" :class="iconForMime(node.attrs.mime)" :style="{ color: mimeColor.color }"></i>
      </div>

      <div class="md-attachment-meta">
        <div class="md-attachment-name">{{ node.attrs.name }}</div>

        <div class="md-attachment-progress-wrap">
          <div class="md-attachment-progress-bar" :style="{ width: progress + '%' }"></div>
        </div>

        <div class="md-attachment-sub">
          Uploading… {{ progress }}% · {{ formatBytes(node.attrs.size) }}
        </div>
      </div>

      <button class="md-attachment-btn md-attachment-remove" @click.stop="cancelUpload">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div v-else-if="node.attrs.error" class="md-attachment md-attachment-card md-attachment-error">
      <div class="md-attachment-left" style="background:#fdecea;">
        <i class="fas fa-exclamation-triangle" style="color:#d32f2f;"></i>
      </div>

      <div class="md-attachment-meta">
        <div class="md-attachment-name">{{ node.attrs.name }}</div>
        <div class="md-attachment-sub">Upload failed: {{ node.attrs.error }}</div>
      </div>

      <button class="md-attachment-btn md-attachment-remove" @click.stop="removeNode">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div v-else-if="node.attrs.kind === 'video'" class="md-media-wrap">
      <video
        :src="node.attrs.src"
        controls
        preload="metadata"
        class="md-media md-media-video"
        :style="videoStyle"
      ></video>

      <button class="md-attachment-btn md-media-remove" @click.stop="removeNode">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div v-else-if="node.attrs.kind === 'audio'" class="md-media-wrap md-media-wrap-audio">
      <div class="md-attachment-left" :style="{ background: mimeColor.bg }">
        <i class="fas fa-file-audio" :style="{ color: mimeColor.color }"></i>
      </div>

      <div class="md-audio-meta">
        <div class="md-attachment-name">{{ node.attrs.name }}</div>
        <audio :src="node.attrs.src" controls preload="metadata"></audio>
      </div>

      <button class="md-attachment-btn md-media-remove" @click.stop="removeNode">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div v-else class="md-attachment md-attachment-card">
      <div class="md-attachment-left" :style="{ background: mimeColor.bg }">
        <i class="fas" :class="iconForMime(node.attrs.mime)" :style="{ color: mimeColor.color }"></i>
      </div>

      <div class="md-attachment-meta">
        <div class="md-attachment-name" :title="node.attrs.name">
          {{ node.attrs.name }}
        </div>

        <div class="md-attachment-sub">
          {{ formatBytes(node.attrs.size) }} · {{ readableFileType(node.attrs.mime, node.attrs.name) }}
        </div>
      </div>

      <div class="md-attachment-actions">
        <a
          v-if="isInlineViewableMime(node.attrs.mime)"
          :href="node.attrs.src"
          target="_blank"
          rel="noopener noreferrer"
          class="md-attachment-btn md-attachment-open"
          @click.stop
        >
          <i class="fas fa-external-link-alt"></i>
        </a>

        <a
          v-else
          :href="node.attrs.src"
          :download="node.attrs.name"
          class="md-attachment-btn md-attachment-download"
          @click.stop
        >
          <i class="fas fa-download"></i>
        </a>

        <button class="md-attachment-btn md-attachment-remove" @click.stop="removeNode">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2'
import {
  iconForMime,
  formatBytes,
  isInlineViewableMime,
  colorForMime,
  readableFileType
} from '../../../utils/attachment-utility'

export default {
  name: 'AttachmentNodeView',
  components: { NodeViewWrapper },
  props: nodeViewProps,

  computed: {
    uploading() {
      return !!this.node.attrs.uploading
    },
    progress() {
      return Number(this.node.attrs.progress) || 0
    },
    mimeColor() {
      return colorForMime(this.node.attrs.mime)
    },
    videoStyle() {
      const width = this.node.attrs.width
      const height = this.node.attrs.height
      if (!width && !height) return ''
      const style = []
      if (width) style.push(`width:${width}`)
      if (height) style.push(`height:${height}`)
      style.push('max-width:100%')
      return style.join(';')
    }
  },

  methods: {
    iconForMime,
    formatBytes,
    isInlineViewableMime,
    readableFileType,

    cancelUpload() {
      const id = this.node.attrs.id
      if (window.__attachmentUploadControllers?.has(id)) {
        const cancel = window.__attachmentUploadControllers.get(id)
        if (cancel) cancel()
      }
      this.removeNode()
    },

    removeNode() {
      if (typeof this.deleteNode === 'function') this.deleteNode()
    }
  }
}
</script>